import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import css from "./index.module.css";

import SEO from "@components/seo";
import MainContent from "@components/content";
import CartProduct from "@components/cartProduct";

import * as Types from "../../types";
import { statusText } from "./order.info";

export default function Order() {
  const { id } = useParams();
  const [order, setOrder] = useState<Types.Order>();

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/user/order/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrder(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  return (
    <MainContent header={`Заказ №${order?.shortID}`}>
      <SEO
        title="Заказ"
        description="Управление заказом"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.order}>
        <div className={css.col1}>
          <div className={css.summaryInfo}>
            <b>{statusText[order?.status!]}</b>
            <a>{new Date(order?.createdAt!).toLocaleString("ru-RU")}</a>
          </div>

          <div className={css.productList}>
            {order?.products.map((item: Types.CartData) => (
              <CartProduct
                id={item.id}
                prodID={item.product.id}
                quantity={0}
                image={item.product.images[0]}
                title={item.product.name}
                price={item.product.price}
                unit={item.product.unit}
                unitCart={item.unit}
                count={item.count}
                width={"100%"}
                buttons={false}
              />
            ))}
          </div>
        </div>

        <div className={css.col2} style={{ flex: 0.1 }}>
          <div className={css.orderInfo}>
            <div className={css.textOrderInfo}>
              <b style={{ fontSize: 20 }}>Склад</b>
              <b style={{ fontSize: 18 }}>Рыбный мир</b>
            </div>

            <div className={css.textOrderInfo}>
              <b style={{ fontSize: 20 }}>Адрес</b>
              <b style={{ fontSize: 18 }}>{order?.address || "Не указано"}</b>
            </div>
          </div>
        </div>
      </div>
    </MainContent>
  );
}
